import type { Editor } from '@tiptap/core';
import { NodeSelection } from '@tiptap/pm/state';

import findNodeByFieldId from './findNodeByFieldId';

// A NodeSelection opens the field's popup; for an atom Dropdown it is the only way to select it.
const selectNodeByFieldId = (editor: Editor, fieldId: string) => {
  const found = findNodeByFieldId(editor, fieldId);
  if (!found) return;
  const sel = NodeSelection.create(editor.state.doc, found.pos);
  editor.view.dispatch(editor.state.tr.setSelection(sel).scrollIntoView());
};

export default selectNodeByFieldId;
